import React, { Suspense } from "react";
import TopMenu from "./topMenu/topMenu";
import LeftMenu from "./leftMenu/leftMenu";
import Dialog from "../dialogs/dialogContainer";
import '../css/layout/app.scss'
import { LeftMenuContext } from "../context/leftMenu.context";
import useInitData from "../InitData/initData";
import usePermission from "../components/permission/usePermission";
const AppLayout = (props: any) => {
    useInitData();
    const { isShow } = React.useContext(LeftMenuContext);
    usePermission()
    return (
        <div className="main-app">
            <TopMenu />
            <div className="content">
                <LeftMenu></LeftMenu>
                <div className={isShow ? "main-container" : "main-container width100"}>
                    {props.children}
                </div>
            </div>
            <Dialog></Dialog>

        </div>
    );
};
export default AppLayout;
